import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('h1',[_vm._v("Acceso denegado")]),_c('p',[_vm._v("No tienes los permisos necesarios para acceder a esta página.")]),_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Volver a vista Principal")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }